import { Outlet, useLocation } from 'react-router-dom'
import Box from '@mui/material/Box'
import { HomeFooter } from '@/features/home/components/HomeFooter'
import {
  SurveyEntryChromeProvider,
  useSurveyEntryChromeOptional,
} from '@/features/instrument-onboarding/lib/SurveyEntryChromeContext'
import {
  surveyEntryHeaderBandSx,
  surveyEntryMainSx,
  surveyEntryShellSx,
  surveyExecutionMainSx,
  surveyExecutionShellSx,
} from '@/features/instrument-onboarding/styles/surveyEntryStyles'

function SurveyEntryLayoutInner() {
  const { pathname } = useLocation()
  const isSurveyExecution = /\/survey\/?$/.test(pathname)
  const chrome = useSurveyEntryChromeOptional()
  const isCompletionChrome = chrome?.mode === 'completion'
  const useExecutionShell = isSurveyExecution || isCompletionChrome

  return (
    <Box
      data-testid="survey-entry-layout"
      data-survey-entry-chrome={useExecutionShell ? 'execution' : 'entry'}
      sx={useExecutionShell ? surveyExecutionShellSx : surveyEntryShellSx}
    >
      {/* Entry info only — not survey execution or completion (Figma 5076:7406 canvas). */}
      {useExecutionShell ? null : (
        <Box aria-hidden data-testid="survey-entry-header-band" sx={surveyEntryHeaderBandSx} />
      )}
      <Box component="main" sx={useExecutionShell ? surveyExecutionMainSx : surveyEntryMainSx}>
        <Outlet />
      </Box>
      <HomeFooter testId="survey-entry-footer" />
    </Box>
  )
}

/** Figma 5074-14025 / 5076-7118 — full-viewport survey entry shell (navy band + card + footer). */
export function SurveyEntryLayout() {
  return (
    <SurveyEntryChromeProvider>
      <SurveyEntryLayoutInner />
    </SurveyEntryChromeProvider>
  )
}
